import { gql } from "@apollo/client"

import { useQuery } from "@oysterhr/core"
import {
  Company,
  CompanyPaymentsGroupsArgs,
  DirectDebitConstraint,
  QueryCompanyArgs,
} from "@oysterhr/schema"

export const COMPANY_INVOICES_BATCHES_QUERY = gql`
  query InvoicesBatches($companyId: ID!, $page: Int, $perPage: Int, $searchQuery: String) {
    company(companyId: $companyId) {
      authorizations {
        actions
        fields
      }
      id
      paymentCurrencyCode
      directDebitAuthorized
      directDebitAvailable
      directDebitConstraint {
        blocked
      }
      paymentMethod {
        ... on PaymentMethodStripeAch {
          id
          state
        }
        ... on PaymentMethodStripeSepa {
          id
          state
        }
        ... on PaymentMethodStripeBacs {
          id
          state
        }
        ... on PaymentMethodStripePad {
          id
          state
        }
      }
      paymentsGroups(page: $page, perPage: $perPage, searchQuery: $searchQuery) {
        collection {
          id
          state
          createdAt
          invoicesCount
          referenceCode
          paidAt
          wireSentAt
          amount {
            currencyCode
            formatted
            subunit
            subunitToUnit
          }
        }
        metadata {
          totalCount
          limitValue
        }
      }
    }
  }
`

type QueryPayload = {
  company?: Pick<
    Company,
    | "paymentsGroups"
    | "authorizations"
    | "directDebitAuthorized"
    | "directDebitAvailable"
    | "paymentsSettings"
    | "paymentCurrencyCode"
    | "paymentMethod"
  > & {
    directDebitConstraint: Pick<DirectDebitConstraint, "blocked">
  }
}

type QueryArgs = QueryCompanyArgs & CompanyPaymentsGroupsArgs

export const useCompanyInvoicesBatches = (args: QueryArgs) =>
  useQuery<QueryPayload, QueryArgs>(COMPANY_INVOICES_BATCHES_QUERY, {
    variables: {
      ...args,
    },
    fetchPolicy: "cache-and-network",
  })
